// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 506 ? "553016b9" : chunkId) + "." + {"38":"9f646c8459a12fc8","506":"b19a4e3fe58cb213","565":"863b6844b27776a1","729":"b6a35964e7a6fca4","739":"1ccd4a106c199494","967":"80ff61f0df5f2425"}[chunkId] + ".js";
};